import CheckCircleGold from "~/assets/check-circle-gold.svg";
import CheckCircleGrey from "~/assets/check-circle-grey.svg";
import "./ProgressBarLabel.css";

const ProgressBarLabel = ({ totalItems, discountTier }) => {
  return (
    <div className="progress-bar-labels-wrapper">
      {Object.entries(discountTier).map(([items, discount], index) => (
        <div
          key={index}
          className={`progress-bar-label-wrapper discount-item ${
            parseInt(items) <= totalItems ? "active" : ""
          }`}>
          <span className="check-circle">
            {parseInt(items) <= totalItems ? <CheckCircleGold /> : <CheckCircleGrey />}
          </span>
          <span className="item-count">{items} items</span>
          <span className="discount">-{discount}%</span>
        </div>
      ))}
    </div>
  );
};

export default ProgressBarLabel;
